import { Link, useLocation } from 'react-router-dom'
import { matchPath } from 'react-router'
import { Container } from './styles'
import { KeyboardArrowLeft } from '@mui/icons-material'
import { Button } from '@mui/material'
import { translate } from '../../../../i18n/index'

export type ParamsTypeProps = {
  title: string
  slug: string
  route?: string
}

export type HeaderStepsProps = {
  params?: ParamsTypeProps
}

const HeaderSteps = ({ params }: HeaderStepsProps) => {
  const location = useLocation()
  const routes = [

    {
      route: '/home-bezerra',
      slug: '/bezerra/minhas-tarefas'
    },
    {
      route: '/bezerra/minhas-tarefas',
      slug: '/bezerra/tarefa/:id'
    },
    {
      route: '/bezerra/ficha-da-bezerra',
      slug: '/bezerra/ficha-da-bezerra/:id'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/ficha-da-bezerra'
    },

    {
      route: '/bezerra/tratamentos',
      slug: '/bezerra/tratamento/:id'
    },
    {
      route: '/bezerra/tratamentos',
      slug: '/bezerra/novo-tratamento'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/tratamentos'
    },
    {
      route: '/bezerra/graficos',
      slug: '/bezerra/dados-dos-graficos'
    },
    {
      route: '/bezerra/graficos',
      slug: '/bezerra/qualidade-colostro'
    },
    {
      route: '/bezerra/graficos',
      slug: '/bezerra/qualidade-colostro-brix'
    },
    {
      route: '/bezerra/graficos',
      slug: '/bezerra/qualidade-colostro-lgG-cbt'
    },
    {
      route: '/bezerra/graficos',
      slug: '/bezerra/qualidade-colostragem'
    },
    {
      route: '/home-bezerra/',
      slug: '/bezerra/graficos'
    },
    {
      route: '/',
      slug: '/ubere/ficha-da-vaca'
    },
    {
      route: '/ubere/ficha-da-vaca',
      slug: '/ubere/ficha-da-vaca/:id'
    },
    {
      route: '/ubere/analise-cbt-tanque',
      slug: '/ubere/analise-cbt-tanque/:id'
    },
    {
      route: '/',
      slug: '/ubere/resultados/'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/resultados/:id'
    },
    {
      route: '/ubere-lancamento',
      slug: '/ubere/leitura-de-resultados'
    },
    {
      route: '/',
      slug: '/ubere/review-automatic-readings'
    },
    {
      route: '/',
      slug: '/ubere/mass-launches'
    },
    {
      route: '/ubere/resultados',
      slug: '/ubere/adicionar-tratamento/:id'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/leitura-de-resultados/:id'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/exame-microbiologico/:id'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/exame-microbiologico/'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/nova-mastite-clinica-sem-exame/:id'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/nova-mastite-clinica-sem-exame/'
    },
    {
      route: '/ubere/resultados/',
      slug: '/ubere/reprocessar/:id'
    },
    {
      route: '/ubere/ficha-da-vaca',
      slug: '/ubere/importacao-de-dados'
    },
    {
      route: '/',
      slug: '/ubere/tratamentos'
    },
    {
      route: '/ubere/tratamentos',
      slug: '/ubere/tratamentos/:id'
    },
    {
      route: '/ubere/tratamentos',
      slug: '/ubere/tratamentos/compartilhar/:id'
    },
    {
      route: '/ubere/tratamentos',
      slug: '/ubere/novo-tratamento'
    },
    {
      route: '/',
      slug: '/ubere/minhas-tarefas'
    },
    {
      route: '/ubere/minhas-tarefas',
      slug: '/ubere/tarefa/:id'
    },
    {
      route: '/ubere/resultados',
      slug: '/ubere/leitura-de-resultados'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-intramamarios'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-injetaveis'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-anti-inflamatorios'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-intramamario-por-agentes'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/dias-tratamento-intramamario-por-agentes'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/cura-clinica'
    },
    {
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/incidencia-mastite-clinica'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-ocorrencia-mastite-clinica'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-incidencia-mastite-clinica'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-frequencia-de-crescimento'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-prevalencia-de-agentes'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-por-grupo-gram'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-cura-clinica'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-cura-clinica-por-tratamento'
    },
    {
      route: '/ubere/graficos',
      slug: '/ubere/grafico-cura-clinica-por-diagnostico'
    },
    {
      route: '/',
      slug: '/ubere/'
    },
    {
      route: '/',
      slug: '/meus-dados'
    },
    {
      route: '/minhas-contas',
      slug: '/minhas-contas/:id'
    },
    {
      route: '/',
      slug: '/minhas-contas'
    },
    {
      route: '/rastreio-de-pedidos',
      slug: '/rastreio-de-pedidos/:id'
    },
    {
      route: '/',
      slug: '/rastreio-de-pedidos'
    },
    {
      route: '/lactacao',
      slug: '/lactacao/:id'
    },
    {
      route: '/',
      slug: '/lactacao'
    },
    {
      route: '/',
      slug: '/artigos-e-videos'
    },
    {
      route: '/artigos-e-videos',
      slug: '/video/:id'
    },
    {
      route: '/',
      slug: '/usuarios'
    },
    {
      route: '/fazendas',
      slug: '/fazendas/:id'
    },
    {
      route: '/',
      slug: '/fazendas'
    },
    {
      route: '/',
      slug: '/token'
    },
    {
      route: '/',
      slug: '/integracao-parceiros'
    },
    {
      route: '/',
      slug: '/central-de-notificacoes'
    },
    {
      route: '/usuarios',
      slug: '/usuarios/:id'
    },
    {
      route: '/usuarios',
      slug: '/novo-usuario'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/'
    },
    {
      route: '/login',
      slug: '/selecionar-fazenda'
    },
    {
      route: '/selecionar-fazenda',
      slug: '/selecionar-categoria'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/colostragem'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/banco-de-colostro'
    },
    {
      route: '/bezerra/colostragem',
      slug: '/bezerra/nova-colostragem/:id'
    },
    {
      route: '/bezerra/colostragem',
      slug: '/bezerra/nova-colostragem'
    },
    {
      route: '/bezerra/banco-de-colostro',
      slug: '/bezerra/novo-colostro/:id'
    },
    {
      route: '/bezerra/banco-de-colostro',
      slug: '/bezerra/novo-colostro'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/leitura-de-resultados'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra-lancamento'
    },
    {
      route: '/bezerra/doencas',
      slug: '/bezerra/nova-doenca'
    },
    {
      route: '/bezerra/doencas',
      slug: '/bezerra/nova-doenca/:id'
    },
    {
      route: '/bezerra/doencas',
      slug: '/bezerra/adicionar-tratamento/:id'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/doencas'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/relatorios'
    },
    {
      route: '/home-bezerra',
      slug: '/bezerra/relatorios-processados'
    }
  ]
  const items = routes.filter((item) => matchPath(location.pathname, { path: item.slug, exact: true, strict: false }))

  return <Container>
    {
      items && items.length > 0
        ? (
          <Button
            variant="outlined"
            startIcon={<KeyboardArrowLeft style={{ color: '#495057', fontSize: 16 }} />}
            component={Link}
            to={params?.route || items[0].route}
            style={{
              textTransform: 'none',
              fontSize: 14,
              backgroundColor: '#E9ECEF',
              borderRadius: '8px',
              borderWidth: '0px',
              color: '#495057',
              fontWeight: 500,
              fontFamily: 'Open Sans, sans-serif',
              textDecoration: 'none',
              height: '100%',
              lineHeight: 'normal'
            }}
          >
            {translate('labelRetornar')}
          </Button>
        )
        : (
          <Button
            component={Link}
            to={'/'}
            variant="outlined"
            startIcon={<KeyboardArrowLeft style={{ color: '#495057', fontSize: 16 }} />}
            style={{
              textTransform: 'none',
              fontSize: 14,
              backgroundColor: '#E9ECEF',
              borderRadius: '8px',
              borderWidth: '0px',
              color: '#495057',
              fontWeight: 500,
              fontFamily: 'Open Sans, sans-serif',
              textDecoration: 'none',
              height: '100%',
              lineHeight: 'normal'
            }}
          >
            {translate('labelRetornar')}
          </Button>
        )
    }
  </Container>
}

export default HeaderSteps
